import { useState, useEffect, useCallback } from 'react';
import { isExtensionAvailable, pingExtension } from '../api/client';

export type ExtensionStatus =
  | 'checking'
  | 'connected'
  | 'disconnected'
  | 'not_configured';

const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID || '';
const CHECK_INTERVAL = 30000; // Check every 30 seconds

console.log('[ExtensionStatus] EXTENSION_ID configured:', EXTENSION_ID || '(not set)');

export function useExtensionStatus() {
  const [status, setStatus] = useState<ExtensionStatus>('checking');

  const checkStatus = useCallback(async () => {
    console.log('[ExtensionStatus] Checking extension status...');

    if (!EXTENSION_ID) {
      console.warn('[ExtensionStatus] EXTENSION_ID not configured');
      setStatus('not_configured');
      return;
    }

    if (!isExtensionAvailable()) {
      console.warn('[ExtensionStatus] Extension API not available (not in Chrome or extension not allowing external messages)');
      setStatus('disconnected');
      return;
    }

    console.log('[ExtensionStatus] Pinging extension:', EXTENSION_ID);
    const response = await pingExtension(EXTENSION_ID);
    const newStatus = response.success ? 'connected' : 'disconnected';
    console.log('[ExtensionStatus] Status:', newStatus, response);
    setStatus(newStatus);
  }, []);

  useEffect(() => {
    checkStatus();

    const interval = setInterval(checkStatus, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, [checkStatus]);

  return { status, checkStatus };
}
